import { CategorieCritereEnum } from './enums/categorie-critere.enum';
import { TypeMarcheEnum } from './enums/type-marche.enum';

export class TypeMarche {

    public code: TypeMarcheEnum;
    public libelle: String;
    public categorie: string = CategorieCritereEnum[CategorieCritereEnum.CATAGORIE_2];
}
